<template>
  <div class="app flex-row align-items-center">
    <div class="container-fluid">
      <b-row class="justify-content-center login-box">
        <b-col md="6" lg="5" xl="4">
          <div class="text-center mb-15">
              <img class="mb-25 logo-login" :src="`/logo.svg`">
              <!-- <div class="font-400">Administration Dashboard</div> -->
          </div>
          <b-card-group>
            <b-card no-body class="p-20">
              <b-card-body>
                <form @submit.prevent="forgotPassSubmit">
                  <h4 class="font-400 text-center mb-15 color-primary">Reset Password</h4>
                  <div class="font-13 font-300 text-center mb-10">
                    <span>Please enter your new password.</span>
                  </div>
                  <div class="mb-15">
                    <input ref="pw_confirm" v-model="dataUser.new_password" type="password" placeholder="New Password" class="w-100 font-13" v-validate="'required'" name="new_password">
                    <span class="error">{{ errors.first('new_password') }}</span>
                  </div>
                  <div class="mb-20">
                    <input type="password" v-model="dataUser.confirm_password" placeholder="Confirm New Password" class="w-100 font-13" v-validate="'required|confirmed:pw_confirm'" name="confirm_new_password">
                    <span class="error">{{ errors.first('confirm_new_password') }}</span>
                  </div>
                  <div class="mb-10">
                    <button type="submit" class="btn-primary w-100">Reset Password</button>
                  </div>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Auth } from '@/api'
import axios from 'axios'

export default {
  name: 'Login',
  data: () => ({
    notificationSystem: {
      options: {
        success: {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        }
      }
    },
    dataUser: {
      forget_password_token: '',
      new_password: '',
      confirm_password: ''
    }
  }),
  created () {
    this.dataUser.forget_password_token = this.$route.params.slug
    // console.log('path', this.$route.params.slug)
  },
  methods: {
    openPage (event) {
      this.$router.push(event)
    },
    forgotPassSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post('vendor/v1/user/reset_password/', this.dataUser).then(response => {
            // console.log('test', response)
            this.$toast.success('Your password has been changed successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.$router.push('/')
          }).catch(error => {
            console.log('error', error)
            this.$toast.success("Can't find data!", 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    }
  }
}
</script>
